import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadAssignmentsForProject } from 'store/assignments/thunks/loadAssignmentsForProject';
import { loadEmployerAllowancesByBusinessId } from 'store/employerAllowances/thunks/loadEmployerAllowancesByBusinessId.thunk';
import { loadResourcesAndResourceEmployersOfProject } from 'store/resources/thunks/loadResourcesAndResourceEmployersOfProject';

export const openCreateRecordFromWorkCalendarDay = createAsyncThunk(
  'demo/openCreateRecordFromWorkCalendarDay',
  async ({ clockInAt, clockOutAt, resource, projectId }, { dispatch }) => {
    dispatch(loadResourcesAndResourceEmployersOfProject(projectId));
    dispatch(loadAssignmentsForProject(projectId));

    if (resource) {
      dispatch(loadEmployerAllowancesByBusinessId(resource.employerBusinessId));
    }

    const recordInitialData = {
      project: projectId,
      clockInAt: clockInAt,
      clockOutAt: clockOutAt,
      billedClockInAt: clockInAt,
      billedClockOutAt: clockOutAt,
      status: 'OUT',
      resource: resource?.id,
      type: 'WORK',
    };

    return recordInitialData;
  }
);
